import(/* webpackMode: "eager" */ "/var/www/luaitools.com/app/practice/practice.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/luaitools.com/components/PracticeClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/luaitools.com/components/SiteHeader.tsx");
